;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var View = APP.module('View'),
		Collection = APP.module('Collection');

	View.TippingLeaguesList = View.LeaguesList.extend({
		template: JST.TippingLeaguesList,
		ui: {
			share_btn: '.js-share',
			countdown: '.js-countdown'
		},
		initialize: function() {
			this.scrollToTop();
			this.share   = this.getOption('share');
			this.leagues = this.getOption('leagues');
			this.rounds  = this.getOption('rounds');
			this.user    = this.getOption('user');
			this.leagues_for_regeneration = this.getOption('leagues_for_regeneration');

			this.listenTo(this.leagues, 'leagues:errors', this.showErrors);

			var complete = [
				this.rounds.fetch({ cache: true, expires: 60 }),
				this.leagues.show_my_stats().fetch(),
			];

			if (this.leagues_for_regeneration) {
				complete.push(this.leagues_for_regeneration.show_for_regenerate().fetch())
			}

			this.setModelDefaults();

			$.when.apply(null, complete).done(_.bind(this.initTemplate, this));
		}
	});

}(window, APP, Backbone, Marionette, $, _));